import { useCallback, useState } from 'react';
import { DateTime } from 'luxon';
import { useDialogState } from 'modules/common/hooks';

type ReturnValue = {
  startTime?: Date;
  endTime?: Date;
  date?: DateTime;
  openAddNote: boolean;
  onAddNoteClick: (startTime?: Date, endTime?: Date) => void;
  onAddNoteComplete: () => void;
};
export const useAddNoteDialog = (): ReturnValue => {
  const { open, openDialog, closeDialog } = useDialogState();

  const [startTime, setStartTime] = useState<Date | undefined>();
  const [endTime, setEndTime] = useState<Date | undefined>();
  const [date, setDate] = useState<DateTime | undefined>();

  const onAddNoteComplete = useCallback(() => {
    closeDialog();
    setStartTime(undefined);
    setEndTime(undefined);
    setDate(undefined);
  }, [closeDialog]);

  const onAddNoteClick = useCallback(
    (startTime?: Date, endTime?: Date) => {
      setStartTime(startTime);
      setEndTime(endTime);
      if (startTime) {
        const st = DateTime.fromJSDate(startTime);
        setDate(DateTime.local(st.year, st.month, st.day));
      } else if (endTime) {
        const et = DateTime.fromJSDate(endTime);
        setDate(DateTime.local(et.year, et.month, et.day));
      }
      openDialog();
    },
    [openDialog]
  );

  return {
    date,
    startTime,
    endTime,
    openAddNote: open,
    onAddNoteClick,
    onAddNoteComplete
  };
};
